import { render, staticRenderFns } from "./OpinionTable.vue?vue&type=template&id=9bf52274"
import script from "./OpinionTable.vue?vue&type=script&lang=js"
export * from "./OpinionTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports